import { AuditDetails, Entity } from '../entity';
import { Attachment } from '../shared/attachment';
import { WebhookSubscriptionFilters } from '../webhooks-v2/webhook.subscription';
import { AgentHarnessBucketMode, AgentHarnessDrainStrategy } from '../../ai/agent-harness/agent.pending-event.enums';
import { ExtensionRuntimeApplicationIdentity } from './extension.runtime.enrolment';
import type { ExtensionExecutionContract } from '../agents/agent.run.context';

export type OAuth2GrantType = "authorization_code" | "client_credentials" | "refresh_token" | "password" | "implicit" | "urn:ietf:params:oauth:grant-type:token-exchange" | `custom:${string}`;

export enum OAuth2ApplicationType {
    Application = 'application',
    Agent = 'agent',
    Workflow = 'workflow',
}

export enum OAuth2ApplicationAgentTransport {
    Http = 'http',
    Nats = 'nats',
}

export interface OAuth2ApplicationAgentSubscription {
    /** Supplied on transient extension dispatch profiles; legacy subscriptions omit these. */
    definitionRevision?: number;
    capabilityVersion?: string;
    executionContract?: ExtensionExecutionContract;
    _id: string;
    enabled?: boolean;
    entityType: string;
    eventTypes: string[];
    bucketMode: AgentHarnessBucketMode;
    /**
     * Replaces the subscription id in the queue bucket key, so every subscription naming the same group shares one lane per source entity (one active run at a time across them).
     * Extension workflows set it so all workflows on one Job run in order; unset keeps the lane per subscription.
     */
    bucketGroup?: string;
    strategy: AgentHarnessDrainStrategy;
    filters?: WebhookSubscriptionFilters;
    statuses?: string[];
    priorities?: string[];
    instructions?: string;
}

export interface OAuth2ApplicationAgent {
    transport?: OAuth2ApplicationAgentTransport;
    invokeUrl?: string;
    natsSubject?: string;
    signingSecret?: string | null;
    instructions?: string;
    subscriptions: OAuth2ApplicationAgentSubscription[];
}

export interface WorkBuddyOAuth2Application extends Entity, AuditDetails {
    id: string;
    image: Attachment;
    description: string;
    secret?: string | null;
    redirectUris: string[];
    allowedGrants: OAuth2GrantType[];
    scopes: Entity[];
    enabled?: boolean;
    type?: OAuth2ApplicationType;
    agent?: OAuth2ApplicationAgent | null;
    autoRegistered?: boolean;
    runtimeIdentity?: ExtensionRuntimeApplicationIdentity;
}
